export default "__VITE_PUBLIC_ASSET__78660f4e__"